import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE, PERCENTAGE_TAB } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const PERCENTAGE_ACTION_TYPES = {
	GET_PERCENTAGES_SUCCESS: 'GET_PERCENTAGES_SUCCESS',
    POST_PERCENTAGE_URL: 'POST_PERCENTAGE_URL',
    PUT_PERCENTAGE_SUCCESS: 'PUT_PERCENTAGE_SUCCESS',
    DELETE_PERCENTAGE_SUCCESS: 'DELETE_PERCENTAGE_SUCCESS',
    UPDATE_PERCENTAGES_URL: 'UPDATE_PERCENTAGES_URL'
};

const PERCENTAGES_URL = `${ENTRYPOINT}${API_ROUTES.PERCENTAGES}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getPercentages = (data = { page: 0, rowsPerPage: 10, filters: { }}) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_PERCENTAGES_URL = `${PERCENTAGES_URL}${params}`;
        const response = await getData(GET_PERCENTAGES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: PERCENTAGE_ACTION_TYPES.GET_PERCENTAGES_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: PERCENTAGE_ACTION_TYPES.UPDATE_PERCENTAGES_URL, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getPercentage = async (uuid) => {
    const GET_PERCENTAGE_URL = `${PERCENTAGES_URL}/${uuid}`;
    return await getData(GET_PERCENTAGE_URL, getHeaders());
}

export const postPercentage = (data) => {
    return async (dispatch) => {
        const response = await postData(PERCENTAGES_URL, data);
        dispatch({ type: PERCENTAGE_ACTION_TYPES.POST_PERCENTAGE_URL, payload: response });
        return history.push(REACT_ROUTES.ARTICLE_TABS, { selectedTab: PERCENTAGE_TAB });
    }
}

export const putPercentage = (uuid, data) => {
    return async (dispatch) => {
        const PUT_ARTICLE_URL = `${PERCENTAGES_URL}/${uuid}`;
        const response = await putData(PUT_ARTICLE_URL, data);
        dispatch({ type: PERCENTAGE_ACTION_TYPES.PUT_PERCENTAGE_SUCCESS, payload: response });
        history.push(REACT_ROUTES.ARTICLE_TABS, { selectedTab: PERCENTAGE_TAB });
    }
}

export const deletePercentage = (uuid) => (
    async () => {
        const DELETE_PERCENTAGE_URL = `${PERCENTAGES_URL}/${uuid}`;
        await deleteData(DELETE_PERCENTAGE_URL);
        // dispatch({ type: PERCENTAGE_ACTION_TYPES.DELETE_PERCENTAGE_SUCCESS, payload: uuid });
    }
)

export const updatePercentagesPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: PERCENTAGE_ACTION_TYPES.UPDATE_PERCENTAGES_URL, payload: { rowsPerPage, page, filters } });
        dispatch(getPercentages({ page, rowsPerPage, filters }));
    }
}

